<template>
  <div class="d-flex flex-column ipa-image-wrapper">
    <img
      :data-src="imageSource"
      :alt="imageAlt"
      class="mb-space-sm ipa-image ipa-lazy" />
    <div
      v-if="displayCaption && caption"
      :class="captionClass"
      class="mb-space-sm"
      v-html="caption"></div>
    <div class="bg-secondary ipa-line"></div>
  </div>
</template>

<script setup lang="ts">
import lozad from "lozad";
import { computed, onMounted } from "vue";

interface Props {
  displayCaption?: boolean;
  caption?: string;
  captionSize?: "xl" | "large" | "small" | "medium";
  captionVariant?: string;
  imageSource: string;
  imageAlt: string;
}

const props = withDefaults(defineProps<Props>(), {
  displayCaption: true,
  captionSize: "small",
  captionVariant: "dark-1",
});

const captionClass = computed(() => {
  return `fs-${props.captionSize} text-${props.captionVariant}`;
});

onMounted(() => {
  const observer = lozad(".ipa-lazy");
  observer.observe();
});
</script>

<style lang="scss" scoped>
.ipa-image-wrapper {
  width: 100%;
}

.ipa-image {
  height: 450px;
  width: 100%;
  object-fit: cover;
  object-position: top;
}

.ipa-line {
  height: 4px;
  width: 100%;
}
@media (min-width: 992px) {
  .ipa-image {
    height: 600px;
  }
  .ipa-image-wrapper {
    width: 400px;
    margin: 0 auto;
  }
  .ipa-line {
    height: 4px;
  }
}
</style>
